// extracted by mini-css-extract-plugin
module.exports = {"button_linkedin":"linkedin_button_linkedin__13mRs","label_linkedin":"linkedin_label_linkedin__3yHpx"};